import {Button, FormControl, TextInput} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import type {SignUpField} from '../../../Index.types'
import Styles from './SignUpForm.module.css'

interface SignUpFormProps {
  signUp: SignUpField
  formLabel: string
  location: 'intro' | 'footer'
  className?: string
}

export function SignUpForm({signUp, formLabel, location, className}: SignUpFormProps) {
  return (
    <form
      action={signUp.cta.url}
      method="get"
      acceptCharset="UTF-8"
      aria-label={formLabel}
      className={clsx(Styles.SignUpForm, className)}
    >
      <input type="hidden" name="source" value="form-home-signup" />
      <FormControl fullWidth className={Styles.SignUpForm__field}>
        <FormControl.Label className={Styles.SignUpForm__label}>{signUp.label}</FormControl.Label>
        <TextInput
          className={Styles.SignUpForm__input}
          invisible
          type="email"
          name="user_email"
          autoComplete="email"
          autoCapitalize="none"
          spellCheck={false}
          placeholder={signUp.placeholder}
        />
      </FormControl>
      <Button
        type="submit"
        variant="primary"
        className={Styles.SignUpForm__submit}
        {...getAnalyticsEvent({action: signUp.cta.label, tag: 'button', context: 'CTAs', location})}
      >
        {signUp.cta.label}
      </Button>
    </form>
  )
}
